import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CalendarCellItem from "./CalendarCellItem";

const MoreClassesModal = ({ open, onClose, selectedDateLabel, classes, onSelectClass }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: "12px", p: 1 } }}
    >
      <DialogTitle
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ pb: 1 }}
      >
        <Typography variant="h4" fontWeight={700} color="#101828">
          Classes for {selectedDateLabel}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ borderBottom: "none" }}>
        <Box display="flex" flexDirection="column" gap={1.5}>
          {classes.map((item) => (
            <CalendarCellItem
              key={item.id}
              item={item}
              isCompact={false}
              onClick={() => {
                onClose();
                onSelectClass(item);
              }}
            />
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MoreClassesModal;